import { WIDGET_STATUS } from '@/utils/support-widget-bridge';

export const MUTATIONS_SUPPORT_WIDGET = {
  SET_SNAPSHOT: 'setSnapshot',
  SET_SUMMONED: 'setSummoned',
  REQUEST_OPEN: 'requestOpen',
  REQUEST_CLOSE: 'requestClose',
  RESET: 'reset'
};

export const initialState = () => ({
  status: WIDGET_STATUS.IDLE,
  open: false,
  unread: 0,
  attention: 0,
  /* A bolinha no canto: chamada pelo menu ou por uma resposta, ate ser dispensada. */
  summoned: false,
  /* Pedido vindo de FORA do painel (menu, bolinha, aviso de mensagem). Quem
     fala com o iframe e o painel; `seq` sobe a cada pedido para o watch dele
     disparar mesmo com dois pedidos iguais seguidos. */
  request: { open: false, route: null, seq: 0 }
});

export default {
  setSnapshot(state, snapshot) {
    state.status = snapshot.status;
    state.open = Boolean(snapshot.open);
    state.unread = snapshot.unread;
    state.attention = snapshot.attention;
  },

  setSummoned(state, value) {
    state.summoned = Boolean(value);
  },

  requestOpen(state, route) {
    state.request = { open: true, route: route || null, seq: state.request.seq + 1 };
  },

  requestClose(state) {
    state.request = { open: false, route: null, seq: state.request.seq + 1 };
  },

  reset(state) {
    Object.assign(state, initialState(), { request: { open: false, route: null, seq: state.request.seq } });
  }
};
